import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import { UserFragmentFragmentDoc } from '../../fragments/__generated__/userFragment';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUsersQueryVariables = Types.Exact<{
  roleName?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  activeOnly?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: number, email: string, name: string, imageUrl?: string | null, pipedriveId?: string | null, salesforceId?: string | null, salesforceUrl?: string | null, jobTitle?: string | null, locale?: string | null, podId?: number | null, active: boolean, isRobot: boolean, phone?: string | null, birthday?: string | null, comment?: string | null, rfqLimit?: number | null, region?: Types.UserRegionEnum | null, couponLimit: number, roles: Array<{ __typename?: 'Role', id: number, name: string }>, autoAssignmentSettings?: { __typename?: 'AutoAssignmentSettings', customerOrderGrade?: Array<Types.CustomerOrderGradeEnum> | null, languages?: Array<Types.LanguageEnum> | null, maxDeals?: number | null, overloadPossible?: boolean | null, technology?: Array<number> | null } | null, substitutedBy?: Array<{ __typename?: 'OmsSubstitution', createdAt: string, endDate: string, id: number, startDate: string, deputyUser: { __typename?: 'User', name: string, id: number }, user: { __typename?: 'User', name: string, id: number } }> | null, substitutedByArchived?: Array<{ __typename?: 'OmsSubstitution', createdAt: string, endDate: string, id: number, startDate: string, deputyUser: { __typename?: 'User', name: string, id: number }, user: { __typename?: 'User', name: string, id: number } }> | null, substitutingFor?: Array<{ __typename?: 'OmsSubstitution', createdAt: string, endDate: string, id: number, startDate: string, deputyUser: { __typename?: 'User', name: string, id: number }, user: { __typename?: 'User', name: string, id: number } }> | null, substitutingForArchived?: Array<{ __typename?: 'OmsSubstitution', createdAt: string, endDate: string, id: number, startDate: string, deputyUser: { __typename?: 'User', name: string, id: number }, user: { __typename?: 'User', name: string, id: number } }> | null }> | null };


export const GetUsersDocument = gql`
    query getUsers($roleName: [String!], $activeOnly: Boolean) {
  users(roleName: $roleName, activeOnly: $activeOnly) {
    ...userFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      roleName: // value for 'roleName'
 *      activeOnly: // value for 'activeOnly'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;